var React = require('react');

function SearchNew (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.0915","cy":"12.626","r":"7.95","transform":"rotate(-45 12.0915 12.626)","stroke":"currentColor","strokeWidth":"1.2","key":0}),React.createElement("line",{"x1":"18.2431","y1":"18.5655","x2":"22.6979","y2":"23.0203","stroke":"currentColor","strokeWidth":"1.2","key":1})]);
}

SearchNew.defaultProps = {"width":"29","height":"30","viewBox":"0 0 29 30","fill":"none"};

module.exports = SearchNew;

SearchNew.default = SearchNew;
